import { observable } from "mobx";
import { Type } from "class-transformer";
import DistributorRefundCandidateResponse from "./distributorRefundCandidateResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class DistributorRefundCandidatesResponse {
  @observable
  canGenerateRefund!: boolean;

  @observable
  @Type(() => DistributorRefundCandidateResponse)
  items!: DistributorRefundCandidateResponse[];
}
